const isPrimitive = (val: unknown) => Object(val) !== val

export class WeakObj<T, S extends (keyof T)[]> {
    primitiveCache = {} as Record<keyof T, unknown>
    referenceCache = new WeakMap()
    obj = {} as Pick<T, S[number]>
    keys

    constructor(obj: T, keys: S) {
        this.keys = keys
        this.flush(obj)
    }

    flush(obj: Pick<T, S[number]>) {
        this.primitiveCache = {} as Record<keyof T, unknown>
        this.referenceCache = new WeakMap()
        this.obj = {} as Pick<T, S[number]>
        for (const key of this.keys) {
            if (isPrimitive(obj[key])) {
                this.primitiveCache[key] = obj[key]
            } else {
                this.referenceCache.set(obj[key] as object, key)
            }
            this.obj[key] = obj[key]
        }
    }

    refFrom(obj: Pick<T, S[number]>) {
        if (
            !this.keys.every((key) => {
                if (isPrimitive(obj[key])) {
                    return this.primitiveCache[key] === obj[key]
                } else {
                    return this.referenceCache.get(obj[key] as object) === key
                }
            })
        ) {
            this.flush(obj)
        }
        return this.obj
    }
}
